var _path, _g, _path2, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 223,
    viewBox: "0 0 210 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 31,
    width: 192,
    height: 192
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 222.727C157.718 222.727 200.454 179.991 200.454 127.273C200.454 74.5546 157.718 31.8181 105 31.8181C52.2819 31.8181 9.54541 74.5546 9.54541 127.273C9.54541 179.991 52.2819 222.727 105 222.727Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 222.727C157.718 222.727 200.454 179.991 200.454 127.273C200.454 74.5546 157.718 31.8181 105 31.8181C52.2819 31.8181 9.54541 74.5546 9.54541 127.273C9.54541 179.991 52.2819 222.727 105 222.727Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.454 31.8181H9.54541V222.727H200.454V31.8181Z",
    fill: "#FFB742"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 223
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54545 127.273C9.54545 179.991 52.2819 222.727 105 222.727C157.718 222.727 200.455 179.991 200.455 127.273H210V0H0V127.273H9.54545Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6_51)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 28,
    width: 160,
    height: 195
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.091 143.668V158.296H127.273C158.904 158.296 184.545 183.937 184.545 215.568V222.727H25.4545V215.568C25.4545 183.937 51.0964 158.296 82.7273 158.296H85.9091V143.668C72.1975 137.154 62.3415 123.842 60.6973 108.087C56.0639 107.432 52.5 103.451 52.5 98.6365V87.5001C52.5 82.7703 55.94 78.844 60.4545 78.0866V73.1819C60.4545 48.5802 80.3982 28.6365 105 28.6365C129.602 28.6365 149.545 48.5802 149.545 73.1819V78.0866C154.06 78.844 157.5 82.7703 157.5 87.5001V98.6365C157.5 103.451 153.936 107.432 149.303 108.087C147.658 123.842 137.802 137.154 124.091 143.668Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.091 143.668V158.296H127.273C158.904 158.296 184.545 183.937 184.545 215.568V222.727H25.4545V215.568C25.4545 183.937 51.0964 158.296 82.7273 158.296H85.9091V143.668C72.1975 137.154 62.3415 123.842 60.6973 108.087C56.0639 107.432 52.5 103.451 52.5 98.6365V87.5001C52.5 82.7703 55.94 78.844 60.4545 78.0866V73.1819C60.4545 48.5802 80.3982 28.6365 105 28.6365C129.602 28.6365 149.545 48.5802 149.545 73.1819V78.0866C154.06 78.844 157.5 82.7703 157.5 87.5001V98.6365C157.5 103.451 153.936 107.432 149.303 108.087C147.658 123.842 137.802 137.154 124.091 143.668Z",
    fill: "#D0C6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.455 28.6365H25.4545V251.364H235.455V28.6365Z",
    fill: "#FFE6CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.545 91.4774V109.773C149.545 134.375 129.602 154.318 105 154.318C80.3983 154.318 60.4546 134.375 60.4546 109.773V91.4774V103.409C60.4546 128.011 80.3983 147.955 105 147.955C129.602 147.955 149.545 128.011 149.545 103.409V91.4774Z",
    fill: "black",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 145,
    width: 160,
    height: 78
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9091 145.625C71.6556 147.22 60.6771 151.575 60.4579 162.786C39.8892 171.475 25.4545 191.836 25.4545 215.568V222.727H184.545V215.568C184.545 191.836 170.111 171.475 149.542 162.786C149.323 151.575 138.344 147.22 124.091 145.625V160.682C124.091 171.225 115.544 179.773 105 179.773C94.4564 179.773 85.9091 171.225 85.9091 160.682V145.625Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6_51)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9091 145.625C71.6556 147.22 60.6771 151.575 60.4579 162.786C39.8892 171.475 25.4545 191.836 25.4545 215.568V222.727H184.545V215.568C184.545 191.836 170.111 171.475 149.542 162.786C149.323 151.575 138.344 147.22 124.091 145.625V160.682C124.091 171.225 115.544 179.773 105 179.773C94.4564 179.773 85.9091 171.225 85.9091 160.682V145.625Z",
    fill: "#B7C1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 135.227H0V222.727H210V135.227Z",
    fill: "#273C4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1364 184.338V222.727H75.5682V181.483C77.3212 182.525 79.185 183.48 81.1364 184.338ZM134.432 181.483V213.58C134.432 215.117 133.185 216.364 131.648 216.364C130.11 216.364 128.864 215.117 128.864 213.58V184.338C130.815 183.48 132.679 182.525 134.432 181.483Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3546 145.349C60.3824 147.614 52.1022 152.125 52.1022 160.927C52.1022 176.607 78.3822 189.318 105 189.318C131.618 189.318 157.898 176.607 157.898 160.927C157.898 152.125 149.618 147.614 137.645 145.349C144.872 148.014 149.545 152.494 149.545 159.948C149.545 176.169 127.415 189.318 105 189.318C82.585 189.318 60.4545 176.169 60.4545 159.948C60.4545 152.494 65.1279 148.014 72.3546 145.349Z",
    fill: "black",
    fillOpacity: 0.16
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 116,
    width: 32,
    height: 17
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9802 118.625C90.8217 126.175 97.2253 132.045 105 132.045C112.799 132.045 119.218 126.138 120.028 118.555C120.093 117.944 119.411 116.932 118.557 116.932C106.709 116.932 97.6326 116.932 91.5465 116.932C90.6872 116.932 89.896 117.869 89.9802 118.625Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6_51)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9803 118.625C90.8218 126.175 97.2254 132.045 105 132.045C112.799 132.045 119.218 126.138 120.028 118.555C120.093 117.944 119.411 116.932 118.557 116.932C106.709 116.932 97.6326 116.932 91.5465 116.932C90.6873 116.932 89.8961 117.869 89.9803 118.625Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.75 108.182H97.0455C94.8489 108.182 93.0682 109.962 93.0682 112.159V116.932C93.0682 119.128 94.8489 120.909 97.0455 120.909H113.75C115.947 120.909 117.727 119.128 117.727 116.932V112.159C117.727 109.962 115.947 108.182 113.75 108.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.023 143.182C105.855 143.182 109.773 139.264 109.773 134.432C109.773 129.599 105.855 125.682 101.023 125.682C96.1903 125.682 92.2728 129.599 92.2728 134.432C92.2728 139.264 96.1903 143.182 101.023 143.182Z",
    fill: "#FF4F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.977 143.182C113.81 143.182 117.727 139.264 117.727 134.432C117.727 129.599 113.81 125.682 108.977 125.682C104.145 125.682 100.227 129.599 100.227 134.432C100.227 139.264 104.145 143.182 108.977 143.182Z",
    fill: "#FF4F6D"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.4546 103.409C95.4546 106.924 99.7282 109.773 105 109.773C110.272 109.773 114.546 106.924 114.546 103.409",
    fill: "black",
    fillOpacity: 0.16
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3091 89.4467C74.7779 86.4249 78.0852 84.3181 81.9298 84.3181C85.7608 84.3181 89.0583 86.41 90.5348 89.4147C90.9734 90.3073 90.3493 91.0377 89.7197 90.4964C87.7699 88.8202 85.0011 87.7734 81.9298 87.7734C78.9545 87.7734 76.2631 88.7558 74.3252 90.341C73.6167 90.9206 72.8795 90.3305 73.3091 89.4467Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.446 89.4467C120.914 86.4249 124.222 84.3181 128.066 84.3181C131.897 84.3181 135.195 86.41 136.671 89.4147C137.11 90.3073 136.486 91.0377 135.856 90.4964C133.906 88.8202 131.138 87.7734 128.066 87.7734C125.091 87.7734 122.4 88.7558 120.462 90.341C119.753 90.9206 119.016 90.3305 119.446 89.4467Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8876 78.8762C76.0017 74.4942 84.5391 72.037 91.8932 73.843C92.7465 74.0525 93.6081 73.5307 93.8176 72.6774C94.0272 71.8241 93.5053 70.9625 92.652 70.753C84.1115 68.6557 74.2254 71.501 70.294 77.033C69.785 77.7492 69.953 78.7424 70.6692 79.2513C71.3854 79.7603 72.3786 79.5923 72.8876 78.8762Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.113 78.8762C133.999 74.4942 125.461 72.0371 118.107 73.843C117.254 74.0526 116.392 73.5307 116.183 72.6774C115.973 71.8241 116.495 70.9625 117.348 70.753C125.889 68.6557 135.775 71.501 139.706 77.033C140.215 77.7492 140.047 78.7424 139.331 79.2514C138.615 79.7603 137.622 79.5924 137.113 78.8762Z",
    fill: "black",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_6_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 223
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210 0H0V222.727H210V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_6_51)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_6_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 13,
    width: 94,
    height: 66
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.506 31.7548C140.311 29.5117 137.762 27.6077 135.283 25.6984C134.736 25.2775 134.18 24.8667 133.645 24.4299C133.523 24.3306 132.278 23.4386 132.129 23.1104C131.77 22.3206 131.978 22.9356 132.028 21.9932C132.09 20.8015 134.52 17.4358 132.707 16.664C131.909 16.3245 130.486 17.2279 129.721 17.5263C128.225 18.1102 126.71 18.6082 125.162 19.0377C125.904 17.5607 127.317 14.6041 124.661 15.3954C122.591 16.012 120.663 17.597 118.583 18.3427C119.271 17.2148 122.023 13.7199 119.537 13.5246C118.763 13.4637 116.511 14.915 115.678 15.2246C113.183 16.1521 110.635 16.7515 108.015 17.2236C99.1076 18.829 88.6913 18.3712 80.45 22.4266C74.0965 25.5529 67.8227 30.4039 64.1524 36.581C60.6149 42.535 59.2917 49.051 58.5513 55.8737C58.008 60.8808 57.9638 66.0566 58.2179 71.0818C58.3009 72.7282 58.4861 80.3177 60.878 78.0193C62.0697 76.874 62.0609 72.2497 62.361 70.6844C62.9583 67.5701 63.5333 64.4419 64.5292 61.4271C66.2841 56.1145 68.3543 50.4554 72.7263 46.7964C75.5319 44.4486 77.5021 41.2753 80.1869 38.9066C81.3929 37.8428 80.4726 37.9536 82.4117 38.0932C83.7143 38.1868 85.0228 38.2226 86.3281 38.2568C89.3477 38.3352 92.372 38.3152 95.3923 38.3259C101.475 38.3478 107.529 38.4337 113.606 38.1153C116.307 37.9739 119.015 37.8973 121.708 37.6475C123.212 37.5079 125.882 36.5436 127.121 37.2805C128.254 37.9546 129.431 40.1559 130.245 41.0575C132.168 43.188 134.461 44.8153 136.709 46.5623C141.398 50.205 143.765 54.7803 145.189 60.473C146.607 66.1446 146.21 71.4065 147.966 76.9879C148.274 77.9692 149.092 79.6608 150.099 78.1446C150.286 77.863 150.237 76.3151 150.237 75.4245C150.237 71.8292 151.148 69.1316 151.136 65.5129C151.092 54.5102 150.736 40.1631 142.506 31.7548Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_6_51)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.506 31.7549C140.311 29.5117 137.762 27.6077 135.283 25.6984C134.736 25.2775 134.18 24.8668 133.645 24.4299C133.523 24.3306 132.278 23.4386 132.129 23.1104C131.77 22.3206 131.978 22.9356 132.028 21.9932C132.09 20.8015 134.52 17.4358 132.707 16.664C131.909 16.3245 130.486 17.2279 129.721 17.5263C128.224 18.1102 126.71 18.6082 125.162 19.0377C125.904 17.5607 127.317 14.6041 124.661 15.3954C122.591 16.012 120.663 17.597 118.583 18.3427C119.271 17.2148 122.023 13.7199 119.537 13.5246C118.763 13.4637 116.511 14.915 115.678 15.2246C113.183 16.1521 110.635 16.7515 108.015 17.2236C99.1075 18.829 88.6912 18.3712 80.4499 22.4266C74.0964 25.5529 67.8226 30.4039 64.1523 36.581C60.6147 42.535 59.2916 49.051 58.5512 55.8738C58.0079 60.8808 57.9637 66.0566 58.2178 71.0818C58.3008 72.7282 58.486 80.3177 60.8779 78.0193C62.0696 76.8741 62.0608 72.2497 62.3609 70.6844C62.9582 67.5701 63.5332 64.4419 64.5291 61.4271C66.284 56.1145 68.3542 50.4554 72.7261 46.7964C75.5318 44.4486 77.502 41.2753 80.1868 38.9066C81.3928 37.8428 80.4725 37.9536 82.4116 38.0932C83.7142 38.1868 85.0227 38.2226 86.328 38.2568C89.3476 38.3352 92.3719 38.3152 95.3922 38.3259C101.475 38.3478 107.529 38.4337 113.606 38.1153C116.307 37.9739 119.014 37.8973 121.708 37.6475C123.212 37.5079 125.882 36.5436 127.121 37.2805C128.254 37.9546 129.431 40.1559 130.245 41.0575C132.168 43.188 134.46 44.8153 136.709 46.5623C141.397 50.2051 143.765 54.7803 145.189 60.473C146.607 66.1446 146.209 71.4065 147.965 76.9879C148.274 77.9692 149.091 79.6608 150.099 78.1446C150.286 77.863 150.237 76.3151 150.237 75.4245C150.237 71.8292 151.148 69.1317 151.136 65.5129C151.092 54.5102 150.736 40.1631 142.506 31.7549Z",
    fill: "#1F3140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.205 0H-0.795288V222.727H209.205V0Z",
    fill: "#2C1B18"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.3411 105.795H78.1474C67.0687 105.795 60.4548 99.699 60.4548 89.4886C60.4548 81.2373 61.9001 73.1818 79.1718 73.1818H81.5105C98.7822 73.1818 100.228 81.2373 100.228 89.4886C100.228 99.0886 92.0512 105.795 80.3411 105.795ZM79.0568 77.9545C63.6366 77.9545 63.6366 83.3962 63.6366 90.2853C63.6366 95.9094 66.1154 102.614 77.9317 102.614H80.3411C90.1769 102.614 97.0457 97.5442 97.0457 90.2853C97.0457 83.3962 97.0457 77.9545 81.6255 77.9545H79.0568Z",
    fill: "#252C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.659 105.795H127.465C116.387 105.795 109.773 99.699 109.773 89.4886C109.773 81.2373 111.218 73.1818 128.49 73.1818H130.829C148.1 73.1818 149.546 81.2373 149.546 89.4886C149.546 99.0886 141.369 105.795 129.659 105.795ZM128.375 77.9545C112.955 77.9545 112.955 83.3962 112.955 90.2853C112.955 95.9094 115.436 102.614 127.25 102.614H129.659C139.495 102.614 146.364 97.5442 146.364 90.2853C146.364 83.3962 146.364 77.9545 130.944 77.9545H128.375Z",
    fill: "#252C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6458 77.7728C56.1957 77.2356 62.2123 73.1818 79.1479 73.1818C93.3478 73.1818 96.3537 74.6555 100.904 76.8821L101.237 77.0465C101.553 77.1583 103.171 77.7078 105.063 77.7682C106.787 77.6942 108.262 77.227 108.692 77.0773C113.886 74.5516 118.969 73.1818 130.852 73.1818C147.788 73.1818 153.805 77.2356 154.354 77.7728C155.654 77.7728 156.705 78.7989 156.705 80.0683V82.3638C156.705 83.6332 155.654 84.6593 154.354 84.6593C154.354 84.6593 148.865 84.6593 148.865 86.9548C148.865 89.2503 147.304 83.6332 147.304 82.3638V80.128C144.438 79.0311 139.307 76.9889 130.852 76.9889C121.433 76.9889 116.742 78.6593 112.718 80.3179L112.763 80.4264L112.761 82.0063L110.997 86.2619L108.819 85.4006C108.624 85.3237 108.204 85.1855 107.622 85.0419C105.999 84.6417 104.331 84.5198 102.856 84.8227C102.314 84.9338 101.812 85.1005 101.351 85.3258L99.2494 86.3528L97.1464 82.2469L97.2398 80.4218L97.304 80.2667C93.8336 78.6496 90.6336 76.9889 79.1479 76.9889C70.6939 76.9889 65.5632 79.0303 62.6964 80.1272V82.3638C62.6964 83.6332 60.3462 89.2503 60.3462 86.9548C60.3462 84.6593 55.6458 84.6593 55.6458 84.6593C54.3485 84.6593 53.2956 83.6332 53.2956 82.3638V80.0683C53.2956 78.7989 54.3485 77.7728 55.6458 77.7728Z",
    fill: "#252C2F"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_51",
    x: 47.2804,
    y: 70.1742,
    width: 115.439,
    height: 44.644,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00758
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.00758
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_51"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_51",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.a4f893b5944e90de5000bf4253089b5a.svg";
export { ForwardRef as ReactComponent };